import React from 'react';
import { Link } from 'react-router-dom';
import BlobButton from './BlobButton';
import MobileSlider from './MobileSlider';

const services = [
  {
    icon: (
      <img 
        src="https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/yy2wwxuo_Book%20Publishing.gif" 
        alt="Book Publishing"
        className="w-full h-full object-contain"
      />
    ),
    title: 'Book Publishing',
    description: 'Complete publishing solutions from manuscript to market, including ISBN, formatting, and distribution.',
    features: ['ISBN Registration', 'Global Distribution', 'Print & Digital'],
    link: '/book-publishing'
  },
  {
    icon: (
      <img 
        src="https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/bcotvt2u_Book%20Writing.gif" 
        alt="Book Writing"
        className="w-full h-full object-contain"
      />
    ),
    title: 'Book Writing',
    description: 'Professional ghostwriting services to bring your ideas to life with compelling narratives.',
    features: ['Expert Writers', 'All Genres', 'Unlimited Revisions'],
    link: '/book-writing'
  },
  {
    icon: (
      <img 
        src="https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/vzwetzug_Book%20Editing.gif" 
        alt="Book Editing"
        className="w-full h-full object-contain"
      />
    ),
    title: 'Book Editing',
    description: 'Comprehensive editing services including developmental, copy, and line editing.',
    features: ['Professional Editors', 'Fast Turnaround', 'Quality Assured'],
    link: '/book-editing'
  },
  {
    icon: (
      <img 
        src="https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/et3956dc_Book%20Design.gif" 
        alt="Book Design"
        className="w-full h-full object-contain"
      />
    ),
    title: 'Book Design',
    description: 'Eye-catching cover designs and interior formatting that captivates readers.',
    features: ['Custom Designs', 'Print & Digital', 'Unlimited Concepts'],
    link: '/book-design'
  },
  {
    icon: (
      <img 
        src="https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/z8ort0i6_Audiobook%20Production.gif" 
        alt="Audiobook Production"
        className="w-full h-full object-contain"
      />
    ),
    title: 'Audiobook Production',
    description: 'Professional narration and production for audiobook distribution platforms.',
    features: ['Pro Narrators', 'Studio Quality', 'ACX Compliant'],
    link: '/audiobook-production'
  },
  {
    icon: (
      <img 
        src="https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/k0ofao43_Book%20Marketing.gif" 
        alt="Book Marketing"
        className="w-full h-full object-contain"
      />
    ),
    title: 'Book Marketing',
    description: 'Strategic marketing campaigns to maximize your book\'s reach and sales.',
    features: ['Social Media', 'PR Services', 'Launch Strategy'],
    link: '/book-marketing'
  }
];

const Services = () => {
  const renderServiceCard = (service, index) => (
    <div
      className="group relative bg-white rounded-2xl p-6 md:p-8 shadow-2xl hover:shadow-xl transition-all duration-300 flex flex-col h-full"
    >
      {/* Icon - Left Aligned */}
      <div className="mb-4 md:mb-6 flex items-start">
        <div className="w-16 h-16 md:w-20 md:h-20 flex-shrink-0">
          {service.icon}
        </div>
      </div>

      {/* Content */}
      <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 md:mb-3">{service.title}</h3>
      <p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6 leading-relaxed">{service.description}</p>

      {/* Features */}
      <ul className="space-y-2 mb-4 md:mb-6 flex-grow">
        {service.features.map((feature, idx) => (
          <li key={idx} className="flex items-center text-xs md:text-sm text-gray-700">
            <span className="w-1.5 h-1.5 bg-amber-700 rounded-full mr-2 flex-shrink-0"></span>
            {feature}
          </li>
        ))}
      </ul>

      {/* Button aligned to bottom */}
      <Link to={service.link}>
        <BlobButton className="w-full mt-auto text-sm md:text-base">
          Learn More
        </BlobButton>
      </Link>
    </div>
  );

  return (
    <section className="py-12 md:py-20 bg-transparent">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-16">
          <div className="inline-flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 border-2 border-amber-700 rounded-full mb-4 md:mb-6">
            <span className="text-amber-700 text-xs md:text-sm font-semibold tracking-wider">OUR SERVICES</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4 px-4">
            Expert Publishing <span className="text-amber-700">Services</span>
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            From manuscript to market, we handle every aspect of the publishing process with excellence and expertise.
          </p>
        </div>

        {/* Mobile Slider (visible on small screens) */}
        <div className="md:hidden">
          <MobileSlider
            items={services}
            renderItem={renderServiceCard}
          />
        </div>

        {/* Desktop Grid (hidden on mobile) */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, index) => (
            <div key={index}>
              {renderServiceCard(service, index)}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Services;